import * as React from 'react';
import {Link as RoutedLink} from 'react-router-dom';

import {EmptyStateLarge} from 'shells/empty-states/empty-state-large';
import {LockIcon} from 'shells/icon';
import {Link} from 'shells/link/link';
import {MarketingHeader} from 'shells/typography/marketing-header';

import styles from './email-syncing-empty-state.module.css';

export function EmailSyncingEmptyState() {
    return (
        <React.Fragment>
            <MarketingHeader>See emails from your contacts in Nutshell</MarketingHeader>
            <div className={styles['empty-state-container']}>
                <EmptyStateLarge
                    icon={
                        <img
                            alt=''
                            style={{width: 280}}
                            src='/include/images/email-drip/email-sent-inbox-unconfigured_2x.png'
                        />
                    }
                    iconSide='right'
                    title=''
                    detailTextBullets={[
                        'Automatically import your email into Nutshell from your inbox.',
                        'Email between you and your prospects will show up on timelines so you’ll always have the full conversation in front of you.',
                        'Only share what you want. By default, Nutshell will never share your emails with your colleagues. You’ll be able to selectively share which emails you’d like.',
                    ]}
                    cta={
                        <Link
                            // @ts-expect-error
                            as={RoutedLink}
                            variant='button'
                            size='big'
                            to={{
                                hash: '/connect-email/get-started',
                                state: {modal: true},
                            }}
                        >
                            Set up and turn on mail sync
                        </Link>
                    }
                />
                <div className={styles['security-message-container']}>
                    <LockIcon size={24} />
                    We’ll never share your data
                </div>
            </div>
        </React.Fragment>
    );
}
